// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1rGkr","image":"styles_image__2NtRA","customerName":"styles_customerName__2qx-L","avatar":"styles_avatar__OjWaz","subTitle":"styles_subTitle__1qSMj"};